import serverInterface from 'server-interface';

import ContactResultRow from '../contact-result-row';

class ContactSearchStrategy {

  async search(searchTerm) {

    const response = await serverInterface.startup.users.customers.searchCustomers(searchTerm);

    const results = response.map(function mapContact(contact) {
      return {
        type: 'CONTACT',
        data: contact
      };
    });

    return results;

  }

  async loadRecentSearchResults() {

    const response = await serverInterface.startup.recentSearchResults.getRecentSearchResults('CONTACT');
    console.log(JSON.stringify(response, null, 2), 'response');
    return response;

  }

  getResultComponentClass() {

    return ContactResultRow;

  }

  getNavigationPath(data) {

    return `/contacts/${data._id}`;

  }

  prepareDataForStorage(data) {

    return data;

  }

}

export default ContactSearchStrategy;